import {Radio} from 'antd-mobile'
import React, {forwardRef, useImperativeHandle, useState } from 'react';




const Question = (props, ref) => {
    const { finish, yanz } = props;
    const { id, desc, options } = props.item;
    const [newSchema, setNewSchema] = useState({});
    // const [yanz, setYanz] = useState([1, 2, 1]);

    useImperativeHandle(ref, () => {
        return {
            getSchema: () => {
                return newSchema
            }
        }
    })
    const getTag = (index, finish, yanz) => {
        if (!finish) return "";
        const val = yanz && yanz[index];
        if (val === 1) {
            return <div className="cuoicon2 iconfont icon-cuo"></div>;
        } else if (val === 2) {
            return <div className="duiicon2 iconfont icon-zhengque-correct"></div>;
        }
        return "";
    };
    
    const onChange = (item_temp, index_temp) => {
    // 创建选项副本，并重置所有选中状态
    const newOptions = options.map(opt => ({
        ...opt,
        selected: false
    }));
    newOptions[index_temp].selected = true;

    let score = 0;
    let selectedArr = [];

    newOptions.forEach((item) => {
        if (item.selected && item.score !== 0) {
            score += parseInt(item.score);
            selectedArr.push(item);
        }
    });

    if (newOptions[index_temp].score === 0) {
        score = 0;
    }

    const schema = {
        id,
        desc,
        the_score: score,
        options: newOptions,
        selected: selectedArr
    };
    setNewSchema(schema);
    };

    return (

        <div className=''>
            {
                <Radio.Group>
                    {
                        options.map((item, index) => (
                            <div className="wrapper">
                                {getTag(index, finish, yanz)}
                                <Radio value={index} style={{'--font-size':'15px'}} onChange={() => { onChange(item, index) }}>
                                    {String.fromCharCode(65 + index)}、{item.label}
                                </Radio>
                            </div>
                    ))
                    }
                </Radio.Group>
            }
        </div>
    )
};

export default forwardRef(Question);
